/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var SupportDarkGray = function SupportDarkGray(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Support icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['support--dark-gray-1', 'support--dark-gray-2', 'support--dark-gray-3', 'support--dark-gray-4'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 200"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-gray-1'],
    x1: "66.98",
    x2: "66.98",
    y1: "206.78",
    y2: "29.82",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#161616",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-gray-2'],
    x1: "50.11",
    x2: "83.93",
    y1: "455.37",
    y2: "396.78",
    gradientTransform: "matrix(1 0 0 -1 0 567.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#393939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-gray-3'],
    x1: "67.19",
    x2: "134",
    y1: "404.16",
    y2: "404.16",
    gradientTransform: "matrix(1 0 0 -1 0 567.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-gray-4'],
    x2: "67.24",
    y1: "404.16",
    y2: "404.16",
    gradientTransform: "matrix(1 0 0 -1 0 567.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#262626"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-gray-1'], ")"),
    d: "M66.76 102.24L134 141.17V0H0v141.17z",
    opacity: ".4",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-gray-2'], ")"),
    d: "M0 141.07l66.77-38.93L134 141.07 67.24 180z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-gray-3'], ")"),
    d: "M134 141.07v4.9L67.19 184.9V180z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-gray-4'], ")"),
    d: "M67.24 180v4.9L0 146v-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    fillOpacity: ".3",
    d: "M67.19 184.9l-54.2-31.4L0 161.07 67.19 200l66.77-38.93-12.99-7.52-53.78 31.35z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: ".8"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M32.4 135.18l-1-.63-.05-25 1.05.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M63.89 91.64l.09 25-31.58 18.54v-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M32.35 110.18l-1.05-.64 31.54-18.49 1 .59z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d8d",
    d: "M48.83 122.16l-1-.64L79.31 103l1 .59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M48.92 147.16l-1.05-.63-.09-25 1 .64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f6f6f",
    d: "M80.36 103.62l.09 25-31.53 18.54-.09-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M53.94 149.94l-1-.64-.09-25 1.05.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d8d",
    d: "M53.85 124.94l-1.05-.64 31.53-18.49 1.09.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f6f6f",
    d: "M85.42 106.4v25l-31.48 18.54-.09-25z",
    opacity: ".8",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M59 152.81l-1-.64-.09-25 1 .64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d8d",
    d: "M58.91 127.81l-1-.64 31.53-18.49 1.1.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f6f6f",
    d: "M90.49 109.27v25L59 152.81l-.09-25z",
    opacity: ".8",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d8d",
    d: "M64 130.58l-1.1-.63 31.58-18.49 1.05.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M64 155.59l-1-.59-.09-25 1.1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f6f6f",
    d: "M95.51 112.05v25L64 155.59v-25z",
    opacity: ".8",
    style: {
      isolation: 'isolate'
    }
  }));
};
SupportDarkGray.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var SupportDarkGray$1 = SupportDarkGray;

export { SupportDarkGray$1 as default };
